// Where each data product starts. Pure: no React, router or Firebase imports.
import type { CountryCode } from '../config/countries';
import type { DataProductId } from '../config/products';

export const PRODUCT_START_PATHS: Readonly<Record<DataProductId, string>> = {
  activities: '/activities',
  odm: '/odm-area-select',
  flow: '/flow',
};

/** The product's area picker, with the query string it was left with (its country filter), so a Back lands on the same list. */
export function pickerPath(p: DataProductId, search?: string | null): string {
  const q = search && search.startsWith('?') && search.length > 1 ? search : '';
  return `${PRODUCT_START_PATHS[p]}${q}`;
}

/** The product's first page; with a country, opened on that country (?country=XXX). */
export function startPath(p: DataProductId, c?: CountryCode | null): string {
  if (!c) return PRODUCT_START_PATHS[p];
  const query = new URLSearchParams({ country: c });
  return `${PRODUCT_START_PATHS[p]}?${query.toString()}`;
}
